<template>
    <v-alert
        v-if="showAlert"
        :type="alertType"
        :class="[
            'mx-auto',
            'text-center',
            'bg-' + (alertType === 'success' ? 'green-lighten-4' : 'red-lighten-4')
        ]"
        style="position: fixed; top: 20px; left: 0; right: 0; z-index: 9999; max-width: 600px;"
        elevation="2"
        prominent
    >
        {{ alertMessage }}
    </v-alert>
    <v-container fluid>
        <v-card class="pa-4" elevation="2">
            <v-row>
                <v-col class="headline mb-4">
                    <h2>Estadísticas</h2>
                </v-col>
                <v-col cols="12" sm="6" style="text-align: right">
                    <v-btn style="margin-left: 10px"  @click="$router.back()">Volver</v-btn>
                </v-col>
            </v-row>

            <v-data-table
                :items="statistics"
                :headers="headers"
                class="elevation-1"
                no-data-text="No hay estadísticas disponibles"
            >

                <template #item.actions="{ item }">
                    <div class="d-flex justify-end">
                        <v-tooltip text="Gráficas">
                            <template #activator="{ props }">
                                <v-btn
                                    icon
                                    class="ma-1"
                                    v-bind="props"
                                    @click="openUserChart(item)"
                                >
                                    <v-icon>mdi-chart-bar</v-icon>
                                </v-btn>
                            </template>
                        </v-tooltip>
                    </div>
                </template>

            </v-data-table>

            <!-- User Chart Dialog -->
            <v-dialog v-model="userChartDialog" max-width="800">
                <v-card>
                    <v-card-title class="d-flex align-center justify-space-between">
                        <span class="text-h6">Accesos de {{ selectedUser?.name }}</span>
                        <v-btn icon @click="userChartDialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <BarChart :chart-data="userBarData" />
                        <v-row class="mt-4">
                            <v-col cols="6">
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    label="Meses a mostrar"
                                    type="number"
                                    v-model.number="monthsToShow"
                                    min="1"
                                    max="12"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import BarChart from '../../../components/charts/BarChartUsers.vue'

import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()

const alertMessage = ref('')
const alertType = ref('success') // 'success' o 'error'
const showAlert = ref(false)

const selectedUser = ref(null)
const userChartDialog = ref(false)
const userBarData = ref({ labels: [], datasets: [] })
const monthsToShow = ref(6)

const showAlertMessage = (message, type = 'success') => {
    alertMessage.value = message
    alertType.value = type
    showAlert.value = true
    setTimeout(() => {
        showAlert.value = false
    }, 4000)
}

const statistics = ref([])

const headers = [
    { title: 'Usuario', value: 'name', sortable: true},
    { title: 'Visitas', value: 'total', sortable: true},
    { title: 'Acciones', value: 'actions', sortable: false}
]

const fetchStatistics = async () => {
    try {
        const {data} = await axios.get('/api/admin/statistics', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })
        statistics.value = data
    }
    catch (e) {
        console.error('Error loading statistics:', e)
        if (e.response?.status === 401) {
            localStorage.removeItem('token')
            await router.push('/')
        }
        showAlertMessage('Error cargando las estadisticas.', 'error')
    }
}

const openUserChart = async (user) => {
    selectedUser.value = user
    await loadUserChart()
    userChartDialog.value = true
}

const loadUserChart = async () => {
    try {
        const params = {
            months: monthsToShow.value,
            start: currentStartMonth.value.toISOString().substring(0, 7)
        }
        const { data } = await axios.get(`/api/admin/statistics/user/${selectedUser.value.user_id}`, {
            params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        })

        data.labels = data.labels.map(label => {
            const date = new Date(label + '-01')
            return date.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long'
            })
        })

        userBarData.value = data // Esperem que el backend retorni labels + datasets



    } catch (err) {
        showAlertMessage('Error cargando gráfico del usuario.', 'error')
    }
}


const initDate = new Date()
initDate.setMonth(initDate.getMonth() - monthsToShow.value)
const currentStartMonth = ref(initDate)

watch(monthsToShow, () => {
    loadUserChart()
})

onMounted(fetchStatistics)
</script>
